import React from 'react';
import logo from '../images/AgalSoftware.jpg';

const Logo = () => {
  return (
    <div className="flex-shrink-0">
      <img
        className="h-10 w-10 rounded-lg object-contain"
        height={40}
        width={40}
        alt="Agal Software Solutions"
        src={logo}
      />
    </div>
  );
};

export default Logo;
